import {NamaPresenter} from "./NamaPresenter";
import {ajaxJSON} from "../common/NamaCommon";
import ReportUnionHandlingEditorTemplate from "../compiled-templates/ReportUnionHandlingEditorTemplate";
import {dropDownFiltering, prepareAllowedValues} from "../widgets/DropDownListWidget";
import * as OwnerType from "../constants/OwnerType";
import * as PreferencesRequest from "../constants/PreferencesRequest";
import * as metadata from "../common/Metadata";
import {constructDataFromAllowedValues} from "../views/list/ListViewColumns";

export class ReportUnionHandlingEditorPresenter extends NamaPresenter {
    constructor(place) {
        super(place);
    }

    start() {
        let that = this;
        this.mainTable = that.place.mainTable;
        this.pendingResponseId = that.place.pendingResponseId;
        this.fieldTitle = that.place.fieldTitle;
        this.allData = {};
        window.document.body.innerHTML = ReportUnionHandlingEditorTemplate({});
        window.document.body.style.backgroundImage = "none";
        window.document.body.style.backgroundColor = "#f5f1e6";
        $("#selected-field-title").text(decodeURIComponent(this.fieldTitle));
        this.drawWidgets();
    }

    drawWidgets() {
        ajaxJSON("reportUnionHandlingEditor", {
            pendingResponseId: this.pendingResponseId,
            action: "fetchEntities"
        }, (data) => {
            this.selectedEntities = data;
            this.drawSelectedEntitiesGrid(data);
        });
        let that = this;
        $(window).on("resize", () => {
            $("#grid").height(window.innerHeight - $(".toolbar").outerHeight());
            this.grid.resize();
        });
        $("#saveBtn").on('click', () => {
            let gridData = this.grid.dataSource.data();
            let result = {};
            gridData.forEach(e => {
                result[e.entityName] = e.result ? e.result : {type: "Normal"};
            })
            window.okPressed = true;
            window.onbeforeunload = null;
            window.onunload = null;
            ajaxJSON("reportUnionHandlingEditor", {
                pendingResponseId: that.pendingResponseId,
                result: JSON.stringify(result),
                action: "done"
            })
            window.close();
        })
        window.onunload = function (e) {
            if (window.okPressed) return null;
            ajaxJSON("reportUnionHandlingEditor", {
                pendingResponseId: that.pendingResponseId,
                action: "cancel"
            });
        }
    }

    drawSelectedEntitiesGrid(data) {
        let that = this;
        let grid = this.grid = $("#grid").kendoGrid({
            dataSource: {
                data: data,
                pageSize: 30
            },
            pageable: true,
            resizable: true,
            height: window.innerHeight - $(".toolbar").outerHeight(),
            columns: [
                {field: "entityName", title: "Entity Name"},
                {field: "arabicName", title: "Arabic Name"},
                {field: "englishName", title: "English Name"},
                {
                    title: "Handling Type", template: (i) => {
                        return `<div class="d-flex justify-content-between w-100"><input class="handlingInput" id="handing-Input-${i.entityName}" style="width: 65%" uid="${i.uid}" handlingType="${i.handlingType ? i.handlingType : "Normal"}">
                            <button class="btn btn-primary ${i.handlingType !== "Custom" && i.handlingType !== "DifferentField" ? "disabled" : ""} edit-custom-value py-0" style="width: 15%" uid="${i.uid}" handlingType="${i.handlingType ? i.handlingType : "Normal"}">Edit</button>
                            </div>`
                    }
                },
                {
                    title: "Expression", template: (i) => {
                        return `<div class="d-flex justify-content-between w-100" id="expression-${i.entityName}">${i.expression ? i.expression : ""}</div>`
                    }
                }
            ]
        }).getKendoGrid();
        $(".handlingInput").kendoDropDownList({
            filter: "contains",
            dataSource: [
                {"value": "Normal", "text": "Normal"},
                {"value": "Zero", "text": "Zero - No Value"},
                {"value": "Negated", "text": "Negated"},
                {"value": "Custom", "text": "Custom Equation"},
                {"value": "DifferentField", "text": "Different Field"},
            ],
            dataValueField: "value",
            dataTextField: "text",
            filtering: function (ev) {
                dropDownFiltering(ev, this.dataSource);
            },
            change: function (e) {
                let value = e.sender.value();
                if (value) {
                    let targetElement = grid.dataSource.getByUid($(e.sender.element[0]).attr("uid"));
                    $(e.sender.element[0]).parent().siblings(".edit-custom-value").attr("handlingType", value);
                    if (value === "Custom") {
                        that.buildCustomExpressionScreen(targetElement);
                        $(e.sender.element[0]).parent().siblings(".edit-custom-value").removeClass("disabled");
                    } else if (value === "DifferentField") {
                        that.buildDifferentFieldScreen(targetElement);
                        $(e.sender.element[0]).parent().siblings(".edit-custom-value").removeClass("disabled");
                    } else {
                        targetElement.result = {type: value};
                        $(e.sender.element[0]).parent().siblings(".edit-custom-value").addClass("disabled");
                    }
                }
            }
        }).data("kendoDropDownList");
        for (let entity of data) {
            $(`#handing-Input-${entity.entityName}`).data("kendoDropDownList").value(entity.handlingType ? entity.handlingType : "Normal");
        }
        $(".edit-custom-value").on('click', function (e) {
            let dropDownValue = $(e.target).attr("handlingType");
            let targetElement = grid.dataSource.getByUid($(this).attr("uid"));
            if (dropDownValue === "Custom") {
                that.buildCustomExpressionScreen(targetElement);
            } else if (dropDownValue === "DifferentField") {
                that.buildDifferentFieldScreen(targetElement);
            }
        })
    }

    buildCustomExpressionScreen(targetElement) {
        let entityName = targetElement.entityName;
        let existed = "";
        if (targetElement.result && targetElement.result.expression) {
            existed = targetElement.result.expression;
        }
        $("#main-screen").removeClass("d-flex");
        $("#main-screen").addClass("d-none");
        $("body").append(`<div class="d-flex flex-column justify-content-center align-items-center" style="width: 98%;margin: 0 auto" id="expression-screen"> 
                <div class="toolbar d-flex justify-content-end" style="width: 100%;"> 
                    <button class="btn btn-success my-2" id="expression-screen-saveBtn" style="width: 15%">Done</button> 
                </div> 
                <textarea class="text-area" rows="8" style="width: 100%">${existed}</textarea> 
                <div style="width: 100%;"> 
                    <nav id="expression-screen-breadcrumb"></nav> 
                </div> 
             
                <div id="expression-screen-grid"></div> 
                <div class="k-d-flex k-flex-wrap"> 
                    <div id="expression-screen-selectedFieldsGrid"></div> 
                </div> 
            </div>`);
        this.breadcrumb = this.drawBreadCrumb(entityName, "#expression-screen-breadcrumb");
        this.fetchEntityData(entityName, (data) => {
            this.drawGridWithData(data.entityData, "#expression-screen-grid", null);
            this.selectedFromERP = data.selectedFromERP;
            this.drawSelectedFieldsGrid(data.selectedFromERP, "#expression-screen-selectedFieldsGrid");
        })
        $("#expression-screen-saveBtn").on('click', () => {
            let expression = $('textarea').val();
            targetElement.result = {type: "Custom", expression: expression};
            $("#expression-screen").remove();
            $("#main-screen").removeClass("d-none");
            $("#main-screen").addClass("d-flex");
            this.expressionScreenBreadcrumb.destroy();
            this.expressionScreenGrid.destroy();
            $(`#expression-${targetElement.entityName}`).text(expression);
        })
    }

    buildDifferentFieldScreen(targetElement) {
        let entityName = targetElement.entityName;
        $("#main-screen").removeClass("d-flex");
        $("#main-screen").addClass("d-none");
        $("body").append(`<div class="d-flex flex-column justify-content-center align-items-center" style="width: 98%;margin: 0 auto" id="single-field-screen">
                <div style="width: 100%;"> 
                    <nav id="single-field-screen-breadcrumb"></nav> 
                </div>
                <div id="single-field-screen-grid"></div> 
                <div class="k-d-flex k-flex-wrap"> 
                    <div id="single-field-screen-selectedFieldsGrid"></div>
                </div> 
            </div>`);
        this.breadcrumb = this.drawBreadCrumb(entityName, "#single-field-screen-breadcrumb");
        this.fetchEntityData(entityName, (data) => {
            this.drawGridWithData(data.entityData, "#single-field-screen-grid", targetElement);
            this.selectedFromERP = data.selectedFromERP;
            this.drawSelectedFieldsGrid(data.selectedFromERP, "#single-field-screen-selectedFieldsGrid", targetElement);
        })
    }

    drawBreadCrumb(entityName, breadCrumbId) {
        let that = this;
        return this.expressionScreenBreadcrumb = $(breadCrumbId).kendoBreadcrumb({
            items: [{
                type: "rootItem",
                text: entityName,
                showText: true,
                entityType: entityName,
                parentFullName: "",
                tableType: that.tableType
            }], click: (e) => {
                let index = this.breadcrumb.items().indexOf(e.item);
                for (let i = index + 1; i < this.breadcrumb.items().length; i++) {
                    let fullFieldId = this.calcCurrentFullFieldIdFromArray(this.breadcrumb.items().slice(0, i + 1));
                    let data = this.breadcrumb.items()[i].data;
                    if (i === this.breadcrumb.items().length - 1) data = this.expressionScreenGrid.dataSource.data();
                    this.allData[fullFieldId] = data;
                }
                this.breadcrumb.items().splice(index + 1, this.breadcrumb.items().length - index);
                this.expressionScreenGrid.dataSource.data(e.item.data);
                this.expressionScreenGrid.refresh();
            }
        }).getKendoBreadcrumb();
    }

    calcCurrentFullFieldIdFromArray(items) {
        return items.filter(l => l.type !== "rootItem").map(l => l.parentPropertyName).join(".");
    }

    fetchEntityData(entityName, callback, fullName) {
        let that = this;
        if (fullName && this.allData[fullName]) {
            callback(this.allData[fullName]);
            return;
        }
        ajaxJSON("wizardFieldsSelection", {
            fetchEntityModel: entityName,
            action: "fetchEntityData",
            pendingResponseId: this.pendingResponseId,
        }, (data) => {
            let entityJson = data.entityData;
            let lastItemInBreadCrumb = that.breadcrumb.items()[that.breadcrumb.items().length - 1];
            if (lastItemInBreadCrumb.entityType === entityJson.tableName) {
                lastItemInBreadCrumb.tableType = entityJson.tableType;
                if (entityJson.tableType === 'DetailLine') {
                    lastItemInBreadCrumb.detailParentEntity = entityJson.detailParentEntity;
                    lastItemInBreadCrumb.detailFullName = entityJson.detailFullName;
                }
            }
            let entityDataArray = entityJson.properties;
            entityDataArray = entityDataArray.concat(that.fetchAllDetailsProps(entityJson));
            entityDataArray.forEach(function (element) {
                element.display = that.isReferenceField(element) || element.fieldType === 'Genericreference' ? 'block' : 'none';
                element.finalId = that.fetchFullParentNameFromBreadCrumbAndAppendDotIfFound() + element.fullName;
            });
            data.entityData = entityDataArray;
            callback(data);
        }, (e) => {
            console.log(e);
        })
    }

    drawSelectedFieldsGrid(data, gridId, targetElement) {
        let that = this;
        let height = window.innerHeight - ($("textarea").length > 0 ? $("textarea").outerHeight() : 0) -
            ($("#expression-screen>.toolbar").length > 0 ? $("#expression-screen>.toolbar").outerHeight() : 0) -
            ($("#expression-screen-breadcrumb").length > 0 ? $("#expression-screen-breadcrumb").outerHeight() :
                $("#single-field-screen-breadcrumb").length > 0 ? $("#single-field-screen-breadcrumb").outerHeight() : 0);
        let isDifferentFieldScreen = "#single-field-screen-selectedFieldsGrid" === gridId;
        let selectedFieldsGrid = this.selectedFieldsGrid = $(gridId).kendoGrid({
            dataSource: {
                data: data,
                pageSize: 10
            },
            pageable: true,
            height: height / 3,
            columns: [
                {draggable: true, width: "40px"},
                {field: "finalId", title: "Full Id"},
                {field: "arabicName", title: "Arabic Name"},
                {field: "englishName", title: "English Name"},
                {
                    title: "Go To", template: (i) => {
                        let cellHtml = `<div class="d-flex justify-content-center">`;
                        cellHtml += `<button title="Go To Parent" class="btn btn-warning btn-sm d-block goToParentBtn mx-2" final-id='${i.finalId}'>
                        <i class="fa-solid fa-arrow-right" style="font-size: 16px"></i></button>`;
                        cellHtml += that.appendReferenceButtonToCellIfNeeded(i);
                        cellHtml += `</div>`;
                        return cellHtml;
                        return ``;
                   }
                }, {
                    field: "selectedRow", width: "80px", title: "Select", template: (i) => {
                        return `<button class="select-item btn btn-success" uid="${i.uid}">Select</button>`
                    }
                },],
            editable: "inline",
            reorderable: {
                rows: true
            },
        }).getKendoGrid();
        $(gridId).on("click", ".select-item", function (e) {
            let uid = e.target.attributes['uid'].value;
            let currentElement = selectedFieldsGrid.dataSource.getByUid(uid);
            that.onSelectedClick(currentElement, isDifferentFieldScreen, targetElement);
        });
        $(gridId).on("click", ".goToParent", function (e) {
            that.onGoToParentField($(e.target).closest(".goToParent").attr('final-id'));
        });
        $(gridId).on("click", ".fetch-reference", function (e) {
            that.onFetchClicked($(e.target).closest(".fetch-reference").attr('referenceTo'), $(e.target).closest(".fetch-reference").attr('fullName'));
        });
        $(gridId).on("click", ".fetch-generic-reference", function (e) {
            that.onGenericRefFetchClicked($(e.target).closest(".fetch-generic-reference"), $(e.target).closest(".fetch-generic-reference").attr('finalId'), $(e.target).closest(".fetch-generic-reference").attr('uid'))
        });

    }

    async onGoToParentField(finalId) {
        let element = this.selectedFromERP.filter(l => l.finalId === finalId)[0];
        if (!element)
            element = this.selectedFieldsGrid.dataSource.data().filter(l => l.finalId === finalId)[0];
        if (!element || element.parentsPath == undefined)
            return;
        this.breadcrumb.items([this.breadcrumb.items()[0]]);
        this.expressionScreenGrid.dataSource.data(this.breadcrumb.items()[0].data);
        this.expressionScreenGrid.refresh();
        for (let parent of element.parentsPath) {
            let first = this.expressionScreenGrid.dataSource.data().filter(f => f.fullName === parent)[0];
            await this.onFetchClicked(first.referenceTo, first.fullName);
        }
    }

    isReferenceField(element) {
        return element.fieldType === 'Reference' || element.referenceTo;
    }

    fetchFullParentNameFromBreadCrumbAndAppendDotIfFound() {
        return this.calcCurrentFullFieldIdFromBreadCrumb() ? this.calcCurrentFullFieldIdFromBreadCrumb() + "." : ""
    }

    calcCurrentFullFieldIdFromBreadCrumb() {
        return this.calcCurrentFullFieldIdFromArray(this.breadcrumb.items());
    }

    fetchAllDetailsProps(entityJson) {
        let detailsProps = [];
        let detailsArray = entityJson.details;
        for (let i = 0; i < detailsArray.length; i++) {
            let currentDetails = detailsArray[i];
            let detailPropertiesArray = currentDetails.properties;
            detailsProps = detailsProps.concat(detailPropertiesArray);
        }
        return detailsProps;
    }

    drawGridWithData(data, gridId, targetElement) {
        let that = this;
        let height = window.innerHeight - ($("#expression-screen>textarea").length > 0 ? $("#expression-screen>textarea").outerHeight() : 0)
            - ($("#expression-screen>.toolbar").length > 0 ? $("#expression-screen>.toolbar").outerHeight() : 0) -
            ($("#expression-screen-breadcrumb").length > 0 ? $("#expression-screen-breadcrumb").outerHeight() :
                $("#single-field-screen-breadcrumb").length > 0 ? $("#single-field-screen-breadcrumb").outerHeight() : 0);
        let isDifferentFieldScreen = "#single-field-screen-grid" === gridId;
        let grid = this.expressionScreenGrid = $(gridId).kendoGrid({
            dataSource: {
                data: data,
                pageSize: 25,
            },
            height: height * 2 / 3,
            scrollable: true,
            filterable: true,
            sortable: true,
            toolbar: ["search"],
            search: {
                fields: [
                    {name: "fullName", operator: "contains"},
                    {name: "arabicName", operator: "contains"},
                    {
                        name: "englishName", operator: "contains"
                    }],
            },
            columns: [
                {field: "fullName", width: 300, title: "Full Name"},
                {
                    field: "fieldType", width: 120, title: "Reference", nullable: true, template: (i) => {
                        let cellHtml = `<div class="d-flex justify-content-center">`;
                        cellHtml += that.appendReferenceButtonToCellIfNeeded(i);
                        cellHtml += that.appendManualJoinButtonToCellIfNeeded(i);
                        cellHtml += `</div>`;
                        return cellHtml;
                    }
                },
                {field: "arabicName", title: "Arabic Name"},
                {field: "englishName", title: "English Name"},
                {field: "fieldType", title: "Field Type"},
                {
                    field: "selectedRow", width: "80px", title: "Select", template: (i) => {
                        return `<button class="select-item btn btn-success" uid="${i.uid}">Select</button>`
                    }
                },
            ],
            pageable: {
                position: "bottom",
                refresh: true,
                pageSizes: [25, 50, 75, 100, "all"],
                buttonCount: 5,
            },
        }).getKendoGrid();
        $(gridId).on("click", ".fetch-reference", function (e) {
            that.onFetchClicked($(e.target).closest(".fetch-reference").attr('referenceTo'), $(e.target).closest(".fetch-reference").attr('fullName'));
        });
        $(gridId).on("click", ".fetch-generic-reference", function (e) {
            that.onGenericRefFetchClicked($(e.target).closest(".fetch-generic-reference"), $(e.target).closest(".fetch-generic-reference").attr('finalId'), $(e.target).closest(".fetch-generic-reference").attr('uid'))
        });
        $(gridId).on("click", ".select-item", function (e) {
            let uid = e.target.attributes['uid'].value;
            let currentElement = grid.dataSource.getByUid(uid);
            that.onSelectedClick(currentElement, isDifferentFieldScreen, targetElement);
        });
        $(`<div class="form-check">
                  <input class="form-check-input" type="checkbox" id="allowManualJoinForAllFieldTypes">
                  <label class="form-check-label" for="allowManualJoinForAllFieldTypes">Allow Manual Join For All Field Types</label>
                  </div>`).appendTo($(".k-toolbar"));
        $("#allowManualJoinForAllFieldTypes").change(function () {
            that.expressionScreenGrid.dataSource.data(that.expressionScreenGrid.dataSource.data())
        })
        $("#expression-screen-grid").on("click", ".fetch-manual-join", function (e) {
            that.onManualJoinClicked($(e.target).closest(".fetch-manual-join"));
        });
    }

    appendReferenceButtonToCellIfNeeded(element) {
        if (this.isReferenceField(element) || element.fullName.includes("#")) {
            return `<button title="Go Inside Reference" class="btn btn-success btn-sm fetch-reference mx-2" referenceTo='${element.referenceTo}' 
                        fullName='${element.fullName}'><i class="fa-solid fa-arrow-right" style="font-size: 20px"></i></button>`
        } else if (element.fieldType === 'Genericreference') {
            return `<button title="Go Inside Reference" class="btn btn-success btn-sm fetch-reference mx-2" referenceTo='EntitySystemEntry'
                        fullName='${element.fullName}#EntitySystemEntry{"joinBy":"targetId"}'><i class="fa-solid fa-arrow-right" style="font-size: 20px"></i></button>
                        <button title="Go Inside Generic Reference" class="btn btn-primary btn-sm fetch-generic-reference mx-2"
                        finalId='${element.finalId}' uid='${element.originalUid ? element.originalUid : element.uid}' entityTableType="${element.entityTableType}">
                        <i class="fa-solid fa-arrow-right" style="font-size: 20px"></i></button>`
        } else {
            return ``;
        }
    }

    appendManualJoinButtonToCellIfNeeded(element) {
        if (element.fullName.includes("#")) {
            return ``;
        } else if ($("#allowManualJoinForAllFieldTypes") && $("#allowManualJoinForAllFieldTypes").prop('checked'))
            return `<button title="Open Manual Join Dialog" class="btn btn-secondary btn-sm fetch-manual-join mx-2" referenceTo='${element.referenceTo}' 
                        fullName='${element.fullName}' uid='${element.originalUid ? element.originalUid : element.uid}'>
                        <i class="fa-solid fa-hand-holding"></i></button>`;
        else if (this.isReferenceField(element) || element.fieldType === 'Genericreference' || element.fullName === 'id') {
            return `<button title="Open Manual Join Dialog" class="btn btn-secondary btn-sm fetch-manual-join mx-2" referenceTo='${element.referenceTo}' 
                        fullName='${element.fullName}' uid='${element.originalUid ? element.originalUid : element.uid}'>
                        <i class="fa-solid fa-hand-holding"></i></button>`;
        } else {
            return "";
        }
    }

    onManualJoinClicked(target) {
        let that = this;
        let referenceTo = target.attr('referenceTo');
        let fullName = target.attr('fullName');
        let uid = target.attr('uid');
        let dialog = this.buildManualJoinDialog();
        that.manualFieldsDropDown = $("#manual-fields-drop-down").kendoDropDownList({
            filter: "contains",
            enable: false,
            dataValueField: "value",
            dataTextField: "text",
            filtering: function (ev) {
                dropDownFiltering(ev, this.dataSource);
            }
        }).data("kendoDropDownList");
        that.manualEntitiesDropDown = $("#manual-entities-drop-down").kendoDropDownList({
            filter: "contains",
            enable: false,
            dataValueField: "value",
            dataTextField: "text",
            filtering: function (ev) {
                dropDownFiltering(ev, this.dataSource);
            },
            change: function (e) {
                that.manualFieldsDropDown.value("");
                that.manualFieldsDropDown.enable(false);
                if (e.sender.value()) {
                    ajaxJSON("wizardFieldsSelection", {
                        referenceTo: referenceTo,
                        fullName: fullName,
                        entityName: e.sender.value(),
                        action: "fetchManualJoinFieldsByEntity",
                        allowManualJoinForAllFieldTypes: $("#allowManualJoinForAllFieldTypes").prop('checked')
                    }, (data) => {
                        data.unshift({value: "", text: ""});
                        that.manualFieldsDropDown.dataSource.data(data);
                        that.manualFieldsDropDown.enable(true);
                    });
                }
            }
        }).data("kendoDropDownList");
        that.manualTableTypeDropDown = $("#manual-table-type-drop-down").kendoDropDownList({
            filter: "contains",
            dataValueField: "value",
            dataTextField: "text",
            dataSource: [
                {"value": "", "text": ""},
                {"value": "Entity", "text": "Entity"},
                {"value": "DetailLine", "text": "Detail Line"},
                {"value": "SystemTable", "text": "System Table"}],
            change: function (e) {
                that.manualEntitiesDropDown.value("");
                that.manualEntitiesDropDown.enable(false);
                if (e.sender.value()) {
                    ajaxJSON("wizardFieldsSelection", {
                        tableType: e.sender.value(),
                        action: "fetchEntitiesByTableType"
                    }, (data) => {
                        data.unshift({value: "", text: ""});
                        that.manualEntitiesDropDown.dataSource.data(data);
                        that.manualEntitiesDropDown.enable(true);
                    });
                }
            }
        }).data("kendoDropDownList");
        dialog.open();
        dialog.bind("close", function () {
            that.manualTableTypeDropDown.destroy();
            that.manualFieldsDropDown.destroy();
            that.manualEntitiesDropDown.destroy();
            dialog.destroy();
        });

        $("#manual-join-dialog").on("click", ".manual-join-ok-button", function () {
            if (!that.manualTableTypeDropDown.value() || !that.manualEntitiesDropDown.value() || !that.manualFieldsDropDown.value())
                return;
            let gridData = that.expressionScreenGrid.dataSource.data();
            let generatedFromItem = that.expressionScreenGrid.dataSource.getByUid(uid);
            let selectedField = that.manualFieldsDropDown.dataItem();
            if (gridData.filter(f => f.fullName === selectedField.fullName)[0] || !selectedField) {
                dialog.close();
                return;
            }
            selectedField.display = "block";
            selectedField.finalId = that.fetchFullParentNameFromBreadCrumbAndAppendDotIfFound() + selectedField.fullName;
            gridData.splice(gridData.indexOf(generatedFromItem) + 1, 0, selectedField);
            that.expressionScreenGrid.dataSource.data(gridData);
            dialog.close();
            $("#manual-join-dialog").remove();
        });
    }

    buildManualJoinDialog() {
        return $("<div id='manual-join-dialog'></div>").kendoDialog({
            width: "550px",
            title: "Select Manual Join",
            closable: true,
            modal: false,
            content: "<div class='d-flex flex-column align-items-center'>" +
                "<div class='d-flex justify-content-around align-items-center mb-2' style='width:100%'>" +
                "<label for='manual-table-type-drop-down'  style='width:20%;text-align:center;margin: 0'>Table Type</label>" +
                "<input id='manual-table-type-drop-down' style='width:80%'></div>" +
                "<div class='d-flex justify-content-around align-items-center my-2' style='width:100%'>" +
                "<label for='manual-entities-drop-down'  style='width:20%;text-align:center;margin: 0'>Join Entity</label>" +
                "<input id='manual-entities-drop-down' style='width:80%'></div>" +
                "<div class='d-flex justify-content-around align-items-center my-2' style='width:100%'>" +
                "<label for='manual-fields-drop-down' style='width:20%;text-align:center;margin: 0'>Join Field</label>" +
                "<input id='manual-fields-drop-down' style='width:80%'></div>" +
                "<button class='btn btn-success manual-join-ok-button mt-2' style='width:30%;'>Ok</button>" + "</div>",
            close: function () {
                this.destroy();
            }
        }).data("kendoDialog");
    }

    onSelectedClick(currentElement, isDifferentFieldScreen, targetElement) {
        let fullName = currentElement.fullName;
        let id = this.fetchFullParentNameFromBreadCrumbAndAppendDotIfFound() + fullName;
        if (!isDifferentFieldScreen) {
            if (currentElement.fieldType === 'Reference' || currentElement.fieldType === 'Genericreference')
                id += ".code";
            let cursorPos = $('textarea').prop('selectionStart');
            let v = $('textarea').val();
            let textBefore = v.substring(0, cursorPos);
            let textAfter = v.substring(cursorPos, v.length);
            $('textarea').val(textBefore + "@{" + id + "}@" + textAfter);
            $('textarea').focus();
        } else {
            targetElement.result = {type: "DifferentField", expression: id};
            $("#single-field-screen").remove();
            $("#main-screen").removeClass("d-none");
            $("#main-screen").addClass("d-flex");
            this.expressionScreenBreadcrumb.destroy();
            this.expressionScreenGrid.destroy();
            $(`#expression-${targetElement.entityName}`).text(id);
        }
    }

    onGenericRefFetchClicked(e, fieldId, uid) {
        let that = this;
        let req = {};
        let lastItemInBreadCrumb = that.breadcrumb.items()[that.breadcrumb.items().length - 1];
        let entityType = lastItemInBreadCrumb.entityType
        let entityTableType = lastItemInBreadCrumb.tableType;
        if (e.attr('entityTableType') !== "undefined") {
            entityTableType = e.attr('entityTableType');
            entityType = fieldId.slice(fieldId.lastIndexOf("#") + 1, fieldId.lastIndexOf("{"));
            fieldId = fieldId.slice(fieldId.lastIndexOf(":\"") + 2, fieldId.lastIndexOf("\"}"));
        }
        if (entityTableType === "DetailLine") {
            entityType = lastItemInBreadCrumb.detailParentEntity;
            fieldId = lastItemInBreadCrumb.detailFullName + "." + fieldId;
        } else if (entityTableType && entityTableType === "SystemTable") {
            entityType = "MeetingRemark";
            fieldId = "ref20";
        }
        req.owner = {ownerType: OwnerType.Entity, ownerId: entityType};
        req.properties = [PreferencesRequest.META_DATA];
        metadata.fetchPreferences(req, (preferences) => {
            let entityMetadata = preferences[PreferencesRequest.META_DATA];
            let dialog = that.drawDialogForGenericRef(entityMetadata, fieldId);
            dialog.open();

            $("#dialog").on("click", ".entity-select-btn", function () {
                let gridData = that.expressionScreenGrid.dataSource.data();
                let generatedFromItem = that.expressionScreenGrid.dataSource.getByUid(uid);
                let selectedEntity = that.dropDown.value();
                if (gridData.filter(f => f.fullName === generatedFromItem.fullName + "#" + selectedEntity)[0] || !selectedEntity) {
                    dialog.close();
                    dialog.destroy();
                    return;
                }
                let newItem = {
                    arabicName: generatedFromItem.arabicName,
                    englishName: generatedFromItem.englishName,
                    display: "block",
                    fieldType: "Reference",
                    referenceTo: selectedEntity,
                    fullName: generatedFromItem.fullName + "#" + selectedEntity,
                    finalId: generatedFromItem.finalId
                };
                gridData.splice(gridData.indexOf(generatedFromItem) + 1, 0, newItem);
                that.expressionScreenGrid.dataSource.data(gridData);
                dialog.close();
                $("#dialog").remove();
            });
        })
    };

    drawDialogForGenericRef(entityMetadata, fieldId) {
        let that = this;
        let dialog = $("<div id='dialog'></div>").kendoDialog({
            width: "450px",
            title: "Select Entity Type",
            closable: true,
            modal: false,
            content: "<div class='d-flex flex-column align-items-center'><input id='generic-compo' class='my-2'>"
                + "<button class='btn btn-success entity-select-btn'>Ok</button></div>",
            close: function () {
                that.dropDown.destroy();
                dialog.destroy();
            }
        }).data("kendoDialog");
        let allowedEntityTypes = [{text: "", value: "", originText: ""}];
        fieldId = fieldId.substring(that.calcCurrentFullFieldIdFromBreadCrumb().length ? that.calcCurrentFullFieldIdFromBreadCrumb().length + 1 : 0)
        let allowedValues = prepareAllowedValues(metadata.findFieldMetadata(fieldId, entityMetadata));
        if (allowedValues) allowedEntityTypes = constructDataFromAllowedValues(allowedValues);
        that.dropDown = $("#generic-compo").kendoDropDownList({
            filter: "contains",
            dataValueField: "value",
            dataTextField: "text",
            dataSource: allowedEntityTypes,
            filtering: function (ev) {
                dropDownFiltering(ev, this.dataSource);
            }
        }).data("kendoDropDownList");
        return dialog;
    }

    onFetchClicked(referenceTo, parentPropertyName) {
        $(".k-grid-search>input").val("");
        this.expressionScreenGrid.dataSource.filter([]);
        this.breadcrumb.items()[this.breadcrumb.items().length - 1].data = this.expressionScreenGrid.dataSource.data();
        this.fetchEntityData(referenceTo, (data) => this.expressionScreenGrid.dataSource.data(data.entityData),
            this.fetchFullParentNameFromBreadCrumbAndAppendDotIfFound() + parentPropertyName);
        this.breadcrumb.items().push({
            type: "item",
            text: parentPropertyName + " (" + referenceTo + ")",
            showText: true,
            entityType: referenceTo,
            parentPropertyName: parentPropertyName,
            tableType: this.tableType,
        });
        this.breadcrumb.value(this.breadcrumb.items().map(e => e.text).join("/"));
    };

}